import React from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { LanguageProvider } from './hooks/useLanguage';
import { LanguageToggle } from './components/LanguageToggle';
export function App() {
  useMetaPixel();
  return <LanguageProvider data-id="element-0">
      <main className="min-h-screen bg-white text-brand-navy selection:bg-brand-amber selection:text-white" data-id="element-1">
        <LanguageToggle data-id="element-2" />
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <BonusesSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <FinalCTASection data-id="element-8" />
        <Footer data-id="element-9" />
      </main>
    </LanguageProvider>;
}